<template>
    <div class="select-dealer__content-details">
        <picture>
            <source v-if="model.image_webp" :srcset="model.image_webp" type="image/webp" />
            <img class="img-responsive select-model__image" :src="model.image" :alt="model.model_title" />
        </picture>
        <h3 class="capitalise">{{ model.model_title }}</h3>
        <nav v-if="currentStep.step === 'dealerSelect'" class="select-dealer__previous-step">
            <button v-if="deepLinkData && deepLinkData.page === 'dealerSelect'" v-on:click="backToTestDrive" class="select-dealer__previous-link">Edit vehicle</button>
            <button v-else v-on:click="backToModelSelect" class="select-dealer__previous-link">Edit vehicle</button>
        </nav>
        <div class="select-dealer__details-grid--spec-box">
        <KeySpecItem svg="#svg-vehicle-type-default" label="" :value="model.friendly_bodystyle" />
        <KeySpecItem svg="#svg-transmission" label="" :value="model.transmission" />
        <KeySpecItem svg="#svg-fuel-electric" label=""
            :value="model.fuel_type" />
        <KeySpecItem svg="#svg-range-electric" label="" :value="max_ev_range" />
        <KeySpecItem svg="#svg-bhp" label="" :value="bhp" />
        <KeySpecItem svg="#svg-co2" label="" :value="co2Emissions" />
        </div>
        <div  v-if="formSubmitted !== true">
            <h4>Book a 24 hour test drive for <span class="capitalise"> {{ model.model_title }} </span></h4>
            <p v-if="currentStep.step === 'dealerSelect'">Please select a dealership and a date and time which suits you and find out everything you need to know about this <span class="capitalise"> {{ model.model_title }} </span>  on a 24 hour test drive.</p>
            <p v-if="(currentStep.step === 'dateSelect') || (currentStep.step === 'details')">Please select a date and time which suits you at {{ dealer.name}} and find out everything you need to know about this <span class="capitalise"> {{ model.model_title }} </span>  on a personalised test drive.</p>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import KeySpecItem from "./../../../used-vue/components/KeySpecItem.vue";
import NumberFormat from "./../../../used-vue/api/NumberFormat"
export default {
    props: {
        model: Object,
        formSubmitted: Boolean
    },
    components: {
        NumberFormat,
        KeySpecItem,
    },
    computed: {
        ...mapGetters(["currentStep"]),
        ...mapState(["dealer", "time", "date", "deepLinkData"]),
        co2Emissions() {
            if (this.model.co2 == null || this.model.co2 <= 0) {
                return '0 g/km';
            }

            return NumberFormat(this.model.co2, 0) + ' g/km';
        },
        bhp() {
            if (this.model.engine_bhp == null || this.model.engine_bhp <= 0) {
                return '0 bhp';
            }

            return NumberFormat(this.model.engine_bhp, 0) + ' bhp';
        },
        max_ev_range() {
            if (this.model.max_ev_range == null || this.model.max_ev_range <= 0) {
                return '0 miles';
            }

            return NumberFormat(this.model.max_ev_range, 0) + ' miles';
        },
    },
    methods: {
        backToModelSelect(){
            this.$store.dispatch("navigatorStep", this.currentStep.previous);
        },
        backToTestDrive(){
            window.location.href = `/${this.deepLinkData.brand}/book-a-test-drive` 
        }

    }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/cms-content-slices/components/electric-test-drive/SelectedVehicleDetails.vue